import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { observer } from 'mobx-react-lite';
import { Body1, Body2 } from '@sbol/nova';
import { ErrorView } from '../ErrorView';
import styles from './Layout.module.scss';
import { Logo } from '../Logo/Logo';

export const Layout: FC<{
  error?: unknown; // ошибка, пойманная глобальным ErrorBoundary
}> = observer(({ error }) => (
  <>
    {/* Эти ErrorBoundary защищают от зацикливания в случае исключения в области header или footer */}
    <ErrorBoundary fallbackRender={() => null}>
      <header>
        <a href={import.meta.env.VITE_SBER_LINK} className={styles.Logo}>
          <Logo />
        </a>
      </header>
    </ErrorBoundary>

    <main>{!error ? <Outlet /> : <ErrorView error={error} />}</main>

    <ErrorBoundary fallbackRender={() => null}>
      <footer>
        <Body1 className={styles.phone_number}>+7 (495) 500-55-50</Body1>
        <Body2 className={styles.footer_text}>Для звонков из любой точки мира</Body2>

        <Body1 className={styles.phone_number}>900</Body1>
        <Body2 className={styles.footer_text}>Для бесплатных звонков с мобильных на территории РФ</Body2>

        <div className={styles.AddressContainer}>
          <Body2 className={styles.footer_text}>Россия, Москва, 117997, ул. Вавилова, д. 19</Body2>
          <Body2 className={styles.footer_text}>Генеральная лицензия на осуществление банковских операций от 11 августа 2015 года.</Body2>
          <Body2 className={styles.footer_text}>Регистрационный номер — 1481.</Body2>
        </div>

        <Body2 className={styles.footer_text}>
          © 1997—{new Date().getFullYear()}
          <a href={import.meta.env.VITE_SBER_LINK} className={styles.SberLink}>
            ПАО Сбербанк
          </a>
        </Body2>
      </footer>
    </ErrorBoundary>
  </>
));
